import "./AcceptedRequests.css";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useBetween } from "use-between";
import { getTranslatedText as translate } from "../../Localization/Translation";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import DetailedOffer from "../OfferRequests/DetailedOffer/DetailedOffer.js";

const AcceptedRequests = () => {
  const { locale } = useBetween(useSelector((state) => state.useSharedLang));
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (laundryId) => {
    setShow(true);
  };

  var LaundryOffersRequests = [
    {
      id: 1,
      name: "مغسلة السعودية",
      date: "25/12/2020",
      Address: "عنوان الإقامة",
    },
    {
      id: 2,
      name: "مغسلة السعودية",
      date: "25/12/2020",
      Address: "عنوان الإقامة",
    },
    {
      id: 3,
      name: "مغسلة السعودية",
      date: "25/12/2020",
      Address: "عنوان الإقامة",
    },
    {
      id: 4,
      name: "مغسلة السعودية",
      date: "25/12/2020",
      Address: "عنوان الإقامة",
    },
  ];
  let d = "-1";
  var LaundryOffersRequestsList = LaundryOffersRequests.map((Req) => {
    d = Number(d) + 1;
    return (
      <div
        className={
          "request-card row animate__animated animate__fadeInUp animate__delay-" +
          d +
          "s"
        }
        dir="auto"
        key={Req.id}
        id={Req.id}
      >
        <div
          className="col-md-5 request-card-col main-data-request-card-col"
          dir="auto"
        >
          <div className="header-join-req-card">
            <i className="fa fa-building" aria-hidden="true"></i>
            <span>{translate("laundry-name", locale)}:</span>
            <span>{Req.name}</span>
          </div>
          <div className="date-join-req-card">
            <i className="fa fa-calendar" aria-hidden="true"></i>
            <span>{translate("date-of-request", locale)}:</span>
            <span>{Req.date}</span>
          </div>
        </div>
        <div className="col-md request-card-col detail-btn-request-card-col">
          <button className="btn btn-primary" onClick={handleShow}>
            {translate("offer-det-btn", locale)}
          </button>
        </div>
        <div className="col request-card-col earnings-card-col-last row">
          <div className="earnings-card-col col">
            <span>{translate("cost", locale)}</span>
            <div>
              <span>0</span>
              <span>{translate("currency-saudi", locale)}</span>
            </div>
          </div>
          <button className="btn btn-primary col-4">
            {translate("zeroing-cost", locale)}
          </button>
        </div>
      </div>
    );
  });

  return (
    <div className="DeliveryJoinReq-component">
      {LaundryOffersRequestsList}

      <Modal show={show} onHide={handleClose} size="md" dir="auto">
        <Modal.Header className="modal-header">
          {translate("offer-det-btn", locale)}
        </Modal.Header>
        <Modal.Body>
          <DetailedOffer />
        </Modal.Body>
        <Modal.Footer dir="auto">
          <Button variant="secondary" onClick={handleClose}>
            {translate("modal-close-btn", locale)}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AcceptedRequests;
